import { render } from "./FooterComponent.vue?vue&type=template&id=6bcbf730&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=6bcbf730&scoped=true&lang=css"

import exportComponent from "D:\\yuqiang\\笔记\\git-document\\document\\workspace\\modingtech\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcbf730"]])

export default __exports__